import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { sourceLevels } from '@/mocks/sources';

export default function SourceGuide() {
  const [activeId, setActiveId] = useState(sourceLevels[1].id);
  const active = sourceLevels.find((level) => level.id === activeId) ?? sourceLevels[0];

  return (
    <section id="source" className="scroll-mt-16 bg-background-50 py-14 md:py-20 border-t border-background-200/70">
      <div className="px-4 md:px-8">
        <SectionHeading
          icon="ri-hd-line"
          eyebrow="资源与片源"
          title="片源与清晰度：四档清晰度该如何选择"
          desc="片源与清晰度直接影响观感与观看条件。下面按标清、高清、超清与 4K 四档说明常见分辨率、码率范围、封装格式与适用设备，点击标签即可查看对应说明。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {sourceLevels.map((level) => {
            const isActive = level.id === active.id;
            return (
              <button
                key={level.id}
                type="button"
                onClick={() => setActiveId(level.id)}
                aria-pressed={isActive}
                className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium whitespace-nowrap rounded-full cursor-pointer transition-colors ${
                  isActive
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 border border-background-200 hover:bg-primary-100'
                }`}
              >
                <i className="ri-play-list-2-line"></i>
                {level.label}
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
          <div className="lg:col-span-7 p-5 md:p-6 rounded-lg bg-background-100 border border-background-200">
            <div className="flex items-center gap-3">
              <span className="flex items-center justify-center w-11 h-11 rounded-md bg-primary-100 text-primary-700">
                <i className="ri-hd-line text-xl"></i>
              </span>
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{active.label}</h3>
                <p className="text-xs text-foreground-500">常见分辨率 {active.res}</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-7 text-foreground-600">{active.note}</p>

            <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-3">
              <div className="px-4 py-3 rounded-md bg-background-50 border border-background-200">
                <p className="text-xs text-foreground-500">码率范围</p>
                <p className="mt-1 text-sm font-medium text-foreground-900">{active.bitrate}</p>
              </div>
              <div className="px-4 py-3 rounded-md bg-background-50 border border-background-200">
                <p className="text-xs text-foreground-500">封装格式</p>
                <p className="mt-1 text-sm font-medium text-foreground-900">{active.container}</p>
              </div>
              <div className="px-4 py-3 rounded-md bg-background-50 border border-background-200">
                <p className="text-xs text-foreground-500">适用设备</p>
                <p className="mt-1 text-sm font-medium text-foreground-900">{active.suitable}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 p-5 md:p-6 rounded-lg bg-accent-50 border border-accent-200">
            <h3 className="font-heading text-base font-bold text-foreground-950">选择建议</h3>
            <ul className="mt-4 space-y-3">
              {[
                { icon: 'ri-wifi-line', text: '网络一般时优先高清，避免频繁缓冲影响观感。' },
                { icon: 'ri-tv-line', text: '大屏电视或显示器建议超清起步，细节更完整。' },
                { icon: 'ri-hard-drive-2-line', text: '4K 体积较大，观看前留意剩余存储空间。' },
                { icon: 'ri-smartphone-line', text: '移动端流量受限时，标清仍是稳妥选择。' },
              ].map((tip) => (
                <li key={tip.text} className="flex items-start gap-3">
                  <span className="flex items-center justify-center w-7 h-7 shrink-0 rounded-md bg-accent-500 text-background-50">
                    <i className={`${tip.icon} text-sm`}></i>
                  </span>
                  <span className="text-sm leading-6 text-foreground-700">{tip.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}